module.exports = window.ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "window.ReactDOM"
// module id = 35
// module chunks = 0